import React from 'react';

const HelpHeader: React.FC = () => {
  return (
    <header className="sticky top-0 bg-white shadow-sm z-10 px-4 py-3">
      <div className="max-w-5xl mx-auto flex items-center justify-center">
        <img src="/img/logo.png" alt="RepliGo（レプリゴ）" className="h-12" />
        <span className="ml-4 text-3xl md:text-4xl font-bold text-gray-800">ヘルプページ</span>
      </div>
    </header>
  );
};

export default HelpHeader;